import React, { ReactNode } from 'react';
import { Panel } from '@appkit4/react-components/panel';
import LeftArea from '../MainArea/LeftArea';
import RightArea from '../MainArea/RightArea';

interface SplitPanelProps {
    leftContent: ReactNode;
    rightContent: ReactNode;
    isHovered: boolean;
    handleMouseEnter: () => void;
    handleMouseLeave: () => void;
  }
  
  const SplitPanel: React.FC<SplitPanelProps> = ({ leftContent, rightContent, isHovered, handleMouseEnter, handleMouseLeave }) => {
    return (
      <Panel
        className="ap-panel"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{ filter: isHovered ? `brightness(103%)` : 'brightness(95%)', padding: '20px', borderRadius: '10px' }}
      >
        <div className="panel-content" style={{ display: 'flex', alignItems: 'flex-start', padding: '10px' }}>
          <LeftArea>
            {leftContent}
          </LeftArea>
          <RightArea>
            {rightContent}
          </RightArea>
        </div>
      </Panel>
    );
  };
  
  export default SplitPanel;
